module.exports = __webpack_public_path__ + "img/rank_6.44b2164.png";